<template>
    <div class="animated fadeIn">
        <DynamicCardList
                ref="dynamicCardList"
                :searchArgs="[
                        {
                            key: 'parentId',
                            value: '0'
                        }
                 ]"
                :caption="Core.Definition.getDefinition('Liste des produits')"
                :searchFormStructure="dataSearchFormStructure"
                :columns="dataColumns"
                :edit="dataEdit"
                :duplicate="dataDuplicate"
                root="/product/list"
                :trash="dataTrash">
        </DynamicCardList>
        <ModalTrash
                ref="trash"
                root="/product"
                @onTrashSuccess="onTrashSuccess"
                :caption="Core.Definition.getDefinition('Suppression du produit')"
                :message="Core.Definition.getDefinition('Êtes-vous sûr de vouloir supprimer ce produit?')"></ModalTrash>
        <ModalDuplicate
                ref="duplicate"
                root="/product/duplicate"
                @onDuplicateSuccess="onDuplicateSuccess"
                :caption="Core.Definition.getDefinition('Duplication du produit')"
                :message="Core.Definition.getDefinition('Êtes-vous sûr de vouloir dupliquer ce produit?')"></ModalDuplicate>
    </div>
</template>

<script>
    import DynamicCardList from '../../components/DynamicCardList'
    import ModalTrash from '../../components/ModalTrash'
    import ModalDuplicate from '../../components/ModalDuplicate'
    export default {
        name: 'ProductList',
        components: {
            DynamicCardList,
            ModalTrash,
            ModalDuplicate
        },
        mounted() {
            this.init()
        },
        data: function () {
            return {
                Core :window.Core,
                dataColumns: [
                    {
                        label: Core.Definition.getDefinition('ID'),
                        key: 'id',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Titre'),
                        key: 'title',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Type'),
                        key: 'type',
                        type: 'select',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Prix régulier'),
                        key: 'Readable.regularPrice',
                        type: 'text',
                        sortable: false
                    }
                ],
                dataSearchFormStructure: {
                    rows: [
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'id'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'title'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'type'
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    fields: [
                        {
                            id: 'id',
                            type: 'text',
                            label: Core.Definition.getDefinition('ID'),
                            value: ''
                        },
                        {
                            id: 'title',
                            type: 'text',
                            label: Core.Definition.getDefinition('Titre'),
                            value: ''
                        },
                        {
                            id: 'type',
                            type: 'select',
                            label: Core.Definition.getDefinition('Type'),
                            value: null,
                            onSelect: function() {}
                        }
                    ]
                },
                dataEdit: {
                    show: true,
                    text: '<button class="btn btn-sm btn-info"><i class="fa fa-edit"></i></button>',
                    onClick:  this.clickEdit
                },
                dataTrash: {
                    show: true,
                    text: '<button class="btn btn-sm btn-danger"><i class="fa fa-trash"></i></button>',
                    onClick: this.clickTrash
                },
                dataDuplicate: {
                    show: true,
                    text: '<button class="btn btn-sm btn-light"><i class="fa fa-copy"></i></button>',
                    onClick:  this.clickDuplicate
                }
            }
        },
        methods: {
            init() {
            },
            clickEdit(value, cell, row) {
                this.$router.push('/commerce/produits/' + row.id)
            },
            clickDuplicate(value, cell, row) {
                this.$refs.duplicate.open(row.id)
            },
            clickTrash(value, cell, row) {
                this.$refs.trash.open(row.id)
            },
            onTrashSuccess() {
                this.$refs.dynamicCardList.retrieve()
            },
            onDuplicateSuccess() {
                this.$refs.dynamicCardList.retrieve()
            }
        }
    }
</script>
